import { CaretIcon } from './StyledIcon'

import { ArrowIcon } from '@/assets/icons'

export type TriggerProps = {
  open: boolean
  setOpen: (state: boolean) => void
  containerId?: string
}

export function DefaultTrigger({ open, setOpen, containerId }: TriggerProps) {
  return (
    <div id={containerId}>
      <CaretIcon onClick={() => setOpen(!open)} as={ArrowIcon} rotate={open} />
    </div>
  )
}
